import { type FC } from 'react'

import classes from './Logo.module.css'

export const Logo: FC = () => (
  <div className={classes.logo}>
    {null}
  </div>
)
